<template>
  <div class="container">
    <div class="header">
      <img src="../../assets/home/logo.png" alt="">
      <div class="login-btn fr" @click="loginComponents = true" v-if="!token">登录</div>
      <div class="login-btn-login" style="float: right" @click.stop="setSelect" v-else>
        <div class="father">
          <img src="../../assets/images/touxiang.png" class="xiajiantou img" alt="">
<!--          <img v-else :src="avatar" class="xiajiantou img" alt="">-->
          <div class="name">{{ name }}</div>
        </div>
      </div>
<!--      <div class="search-btn fr">搜索 <img src="../../assets/home/sousuo.png" alt=""></div>-->
<!--      <input type="text" class="fr">-->
      <div>
        <el-collapse-transition>
          <div v-show="show3" class="select-content">
            <div class="transition-box" @click="goBack"><span></span>去管理</div>
            <div class="transition-box" @click="logOut"><span></span>退出登录</div>
          </div>
        </el-collapse-transition>
      </div>
    </div>
    <LoginPage style="z-index: 999" @confirmLogin="confirmLogin" class="login-page" @loginTrue="getLogin" v-if="loginComponents"></LoginPage>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import LoginPage from '@/components/common/login'
import {BACK_URL} from '@/conifg'

export default {
  name: "HomeHeader",
  components: {
    LoginPage
  },
  computed: {
    ...mapGetters([
      'token',
      'name',
      'avatar',
    ]),
  },
  data() {
    return {
      show3: false,
      loginComponents: false,
    }
  },
  mounted() {
    document.body.addEventListener('click', (e) => {
      this.show3 = e.target.parentNode.className === 'father"';
    }, false);
  },
  methods: {
    confirmLogin(val) {
      this.loginComponents = val;
    },
    /**
     * 个人信息下拉框
     */
    setSelect() {
      this.show3 = !this.show3
    },
    /**
     * 子组件回传值
     * @param val
     */
    getLogin(val) {
      this.loginComponents = val;
    },
    /**
     * 前往后台
     */
    goBack() {
      window.openUrl(BACK_URL)
    },
    /**
     * 退出登陆
     */
    logOut() {
      const url = window.location.pathname.split('/')[1]
      this.$store.dispatch('LogOut').then(() => {
        location.href = `/login?redirect=${url}`;
      })
    }
  }
}
</script>

<style scoped lang="less">
.container {
  width: 1200px;
  margin: 0 auto;
  position: relative;

  .header {
    padding-top: 46px;
    position: relative;
    img {
      width: 420px;
    }

    .login-btn {
      width: 100px;
      height: 47px;
      background: #D3131A;
      border-radius: 4px;
      margin-left: 83px;
      text-align: center;
      line-height: 47px;
      color: #fff;
      cursor: pointer;
    }

    .login-btn-login {
      margin-left: 20px;
      min-width: 100px;
      height: 47px;
      line-height: 47px;
      cursor: pointer;

      div {
        display: inline-block;
      }

      .img {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        //background-color: red;
        vertical-align: middle;
      }

      .name {
        max-width: 150px;
        vertical-align: middle;
        font-size: 16px;
        margin: 0 5px;
      }

      .xiajiantou {
        vertical-align: middle;
      }
    }

    .search-btn {
      height: 44px;
      width: 100px;
      background: #D3131A;
      border-radius: 0px 4px 4px 0px;
      text-align: center;
      line-height: 44px;
      color: #fff;
      cursor: pointer;

      img {
        vertical-align: middle;
        width: 20px;
      }
    }

    input {
      width: 305px;
      height: 44px;
      background: #FFFFFF;
      border-radius: 4px 0px 0px 4px;
      border: 1px solid #CCCCCC;
    }

    .select-content {
      position: absolute;
      margin-top: 20px;
      right: 0;
      width: 130px;
      height: 94px;
      background: #FFFFFF;
      box-shadow: 0px 2px 4px 0px rgb(0 0 0 / 20%);
      border-radius: 4px;
      z-index: 999;

      .transition-box {
        height: 47px;
        line-height: 47px;
        text-align: left;
        cursor: pointer;
        padding-left: 30px;

        span {
          width: 6px;
          height: 6px;
          background: #D3131A;
          border-radius: 1px;
          display: inline-block;
          margin-right: 5px;
          vertical-align: middle;
        }
      }

      .transition-box:hover {
        color: #D3131A;
      }
    }
  }

  .login-page {
    position: absolute;
    right: 0;
    top: 102px;
  }
}
</style>
